import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataDictionarySlice } from './get';

import { coreDataDictionaryExportReducers, coreDataDictionaryExportWatchers } from './export';
import { coreDataDictionaryObjectNamesReducers, coreDataDictionaryObjectNamesWatchers } from './object-names';
import { coreDataDictionarySearchReducers, coreDataDictionarySearchWatchers } from './search';
import { coreDataDictionaryViewsReducers, coreDataDictionaryViewsWatchers } from './views';

export const coreDataDictionaryReducers = combineReducers({
	export: coreDataDictionaryExportReducers,
	get: getCoreDataDictionarySlice.asyncReducers,
	objectNames: coreDataDictionaryObjectNamesReducers,
	search: coreDataDictionarySearchReducers,
	views: coreDataDictionaryViewsReducers
});

export const coreDataDictionaryWatchers = combineAllWatchers([
	coreDataDictionaryExportWatchers,
	getCoreDataDictionarySlice.asyncWatchers,
	coreDataDictionaryObjectNamesWatchers,
	coreDataDictionarySearchWatchers,
	coreDataDictionaryViewsWatchers
]);
